export const isDevel = () => process.env.NODE_ENV === 'development';

export const pokemonQualityToName = quality => {
	if( quality >= 80 )
		return "Best";
	if( quality >= 60 )
		return "Great";
	if( quality >= 40 )
		return "Good";
	if( quality >= 20 )
		return "Okay";

	return "All";
};

export const parseCommaPokemonIdsIntoArray = csv => {
	if( typeof(csv) === "number" )
		return ['' + csv]; // Only one of them gets sent as a number, not a string

	if( !csv || csv.trim().length === 0 )
		return [];

	return csv.split(",");
};